import { render, staticRenderFns } from "./top-nav.vue?vue&type=template&id=7a5b4437&scoped=true&lang=pug"
import script from "./top-nav.vue?vue&type=script&lang=ts"
export * from "./top-nav.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5b4437",
  null
  
)

export default component.exports